import { pluralize } from '@helpers/StringHelper'

export default (string, count) =>
  count === Infinity
    ? `all ${pluralize(count, string)}`
    : `${count} ${pluralize(count, string)}`
